import { render } from "./TabelleKontakte.vue?vue&type=template&id=699c5252&scoped=true"
import script from "./TabelleKontakte.vue?vue&type=script&lang=js"
export * from "./TabelleKontakte.vue?vue&type=script&lang=js"

import "./TabelleKontakte.vue?vue&type=style&index=0&id=699c5252&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-699c5252"

export default script